var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.bgcolor]},[_c('div',{staticClass:"mx-auto px-4 max-w-7xl sm:px-6 lg:px-8 py-14"},[_c('div',{staticClass:"lg:relative"},[_c('div',{staticClass:"container mx-auto"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }